import { render, staticRenderFns } from "./ClientBalanceWithdraw.vue?vue&type=template&id=896db77e"
import script from "./ClientBalanceWithdraw.vue?vue&type=script&lang=js"
export * from "./ClientBalanceWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports